import Head from "next/head";
import styled from "styled-components";

const StyledWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
  justify-content: center;
  display: flex;
`;
const StyledContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  padding: 1rem 2rem;
  margin-bottom: 4rem;
`;
const StyledRow = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const StyledObject = styled.div`
  width: 200px;
  height: 150px;
  border: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  margin: 6px;
`;
/*

  background-image: linear-gradient(45deg, #aaa 25%, transparent 25%),
    linear-gradient(-45deg, #aaa 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #aaa 75%),
    linear-gradient(-45deg, transparent 75%, #aaa 75%);
      background-size: 20px 20px;
  background-position:
    0 0,
    0 10px,
    10px -10px,
    -10px 0px;
    */
const StyledObjectImage = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;

  background: #333;
  padding: 6px;
  a {
    width: 100%;
    height: 100%;
    transition: 0.2s ease;
    &:hover {
      opacity: 0.7;
    }
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
const StyledObjectFooter = styled.div`
  background-color: #f8f8f8;
  flex: 0 0 30px;
  font-weight: 600;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 0 6px;
  background: #111;
  justify-content: space-between;
  svg {
    height: 12px;
    fill: var(--text-color);
    width: auto;
    transition: 0.2s ease;
    &:hover {
      opacity: 0.5;
    }
  }
  a {
    display: flex;
    align-items: center;
  }
`;
const StyledHeader = styled.div`
  display: flex;
  margin-top: 5rem;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 768px) {
    align-items: flex-start;
    margin-top: 2rem;
  }
  p {
    color: var(--text-color);
    font-size: 1.2rem;
    line-height: 2rem;
    max-width: 700px;
    text-align: center;
    @media screen and (max-width: 768px) {
      text-align: left;
    }
  }
`;
const logosArray = [
  "dark_logo_redact.dev.png",
  "dark_logo_redact.png",
  "redact-icon-dark.png",
  "redact-icon-white.png",
  "white_logo_redact.dev.png",
  "white_logo_redact.png",
];

const screenshotsArray = [
  "deletion-done.png",
  "deletion-form.png",
  "deletion-prompt.png",
  "deletion-screen.png",
  "homepage.png",
  "local-archive.png",
  "scan-browser.png",
  "scheduler.png",
];

const mobileArray = [
  "mobile-1.png",
  "mobile-2.png",
  "mobile-deletion-form.png",
  "mobile-deletion-log.png",
  "mobile-home.png",
];

const bannersArray = ["720x1280.jpg", "1080x1080.jpg", "1080x1350.jpg", "1280x720.jpg"];

const youtubeArray = [
  {
    title: "Discord Messages",
    link: "https://youtu.be/wiJL_XmMsnk",
    thumbnail: "discord-messages.jpg",
  },
  { title: "Discord Dms", link: "https://youtu.be/VeX1f2i15Xs", thumbnail: "discord-dms.jpg" },
  {
    title: "Facebook Posts",
    link: "https://youtu.be/59cOeYy_n2c",
    thumbnail: "facebook-posts.jpg",
  },
];

const SvgDownload = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M16 11h5l-9 10-9-10h5v-11h8v11zm1 11h-10v2h10v-2z" />
  </svg>
);

const SvgLink = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M12.015 7c4.751 0 8.063 3.012 9.504 4.636-1.401 1.837-4.713 5.364-9.504 5.364-4.42 0-7.93-3.536-9.478-5.407 1.493-1.647 4.817-4.593 9.478-4.593zm0-2c-7.569 0-12.015 6.551-12.015 6.551s4.835 7.449 12.015 7.449c7.733 0 11.985-7.449 11.985-7.449s-4.291-6.551-11.985-6.551zm-.015 3c-2.21 0-4 1.791-4 4s1.79 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zm-.004 3.999c-.564.564-1.479.564-2.044 0s-.565-1.48 0-2.044c.564-.564 1.479-.564 2.044 0s.565 1.479 0 2.044z" />
  </svg>
);
const Features = () => {
  return (
    <>
      <Head>
        <title>Redact - Media Kit</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta
          name="description"
          content="Redact - Stay up to date with the latest Redact features. Download latest Redact version and join our Discord for more updates."
        />
        <meta name="keywords" content="redact mass delete privacy free features" />

        <meta property="og:title" content="Redact - Media Kit" />
        <meta
          property="og:description"
          content="Stay up to date with the latest Redact features. Download latest Redact version and join our Discord for more updates."
        />

        <meta property="og:url" content="https://www.redact.dev/features" />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      <StyledWrapper>
        <StyledContainer>
          <StyledHeader>
            <h1 className="hero__title">Media Kit</h1>
            <p>
              Hello! We&apos;ve created some assets to help you use our brand and assets, including
              our logo, content and trademarks.
            </p>
          </StyledHeader>
          <h2>Logo and Icons</h2>
          <StyledRow>
            {logosArray.map((val) => (
              <StyledObject key={val}>
                <StyledObjectImage>
                  <a href={`/images/media-kit/logos/${val}`} download>
                    {/*eslint-disable-next-line @next/next/no-img-element*/}
                    <img src={`/images/media-kit/logos/${val}`} alt={val} />
                  </a>
                </StyledObjectImage>
                <StyledObjectFooter>
                  {val}
                  <a href={`/images/media-kit/logos/${val}`} download>
                    <SvgDownload />
                  </a>
                </StyledObjectFooter>
              </StyledObject>
            ))}
          </StyledRow>
          <h2>Product Screenshots</h2>
          <StyledRow>
            {screenshotsArray.map((val) => (
              <StyledObject key={val}>
                <StyledObjectImage>
                  <a href={`/images/media-kit/desktop/${val}`} download>
                    {/*eslint-disable-next-line @next/next/no-img-element*/}
                    <img src={`/images/media-kit/desktop/${val}`} alt={val} />
                  </a>
                </StyledObjectImage>
                <StyledObjectFooter>
                  {val}
                  <a href={`/images/media-kit/desktop/${val}`} download>
                    <SvgDownload />
                  </a>
                </StyledObjectFooter>
              </StyledObject>
            ))}
          </StyledRow>

          <h2>Mobile Screenshots</h2>
          <StyledRow>
            {mobileArray.map((val) => (
              <StyledObject key={val}>
                <StyledObjectImage>
                  <a href={`/images/media-kit/mobile/${val}`} download>
                    {/*eslint-disable-next-line @next/next/no-img-element*/}
                    <img src={`/images/media-kit/mobile/${val}`} alt={val} />
                  </a>
                </StyledObjectImage>
                <StyledObjectFooter>
                  {val}
                  <a href={`/images/media-kit/mobile/${val}`} download>
                    <SvgDownload />
                  </a>
                </StyledObjectFooter>
              </StyledObject>
            ))}
          </StyledRow>

          <h2>Banners</h2>
          <StyledRow>
            {bannersArray.map((val) => (
              <StyledObject key={val}>
                <StyledObjectImage>
                  <a href={`/images/media-kit/banners/${val}`} download>
                    {/*eslint-disable-next-line @next/next/no-img-element*/}
                    <img src={`/images/media-kit/banners/${val}`} alt={val} />
                  </a>
                </StyledObjectImage>
                <StyledObjectFooter>
                  {val}
                  <a href={`/images/media-kit/banners/${val}`} download>
                    <SvgDownload />
                  </a>
                </StyledObjectFooter>
              </StyledObject>
            ))}
          </StyledRow>

          {/*
          <h2>Walkthrough</h2>
          <StyledRow>
            {youtubeArray.map((val) => (
              <StyledObject key={val.title}>
                <StyledObjectImage>
                  <a href={val.link} target="_blank" rel="noopener noreferrer">
                    <img src={`/images/media-kit/walkthroughs/${val.thumbnail}`} alt={val.title} />
                  </a>
                </StyledObjectImage>
                <StyledObjectFooter>
                  {val.title}
                  <a href={val.link} target="_blank" rel="noopener noreferrer">
                    <SvgLink />
                  </a>
                </StyledObjectFooter>
              </StyledObject>
            ))}
          </StyledRow>
            */}
        </StyledContainer>
      </StyledWrapper>
    </>
  );
};

export default Features;
